import React from 'react';
import { Text } from '@fluentui/react-components';
import { useOrderSectionStyles } from './styles';

interface SectionShellProps {
  title: string;
  icon: React.ReactNode;
  /** Hide the title icon when the section is hosted in a context that
   *  already provides one (e.g. an embedding card with its own chrome). */
  showIcon?: boolean;
  /** Render children with no header and no section chrome (border/padding/bg).
   *  Used when the section is embedded in a card that already supplies the
   *  title + surface (e.g. a phase card), so we don't nest a card-in-card. */
  bare?: boolean;
  children: React.ReactNode;
}

export const SectionShell: React.FC<SectionShellProps> = ({
  title,
  icon,
  showIcon = true,
  bare = false,
  children,
}) => {
  const styles = useOrderSectionStyles();
  if (bare) return <>{children}</>;
  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <Text className={styles.sectionTitle}>
          {showIcon && icon}
          {title}
        </Text>
      </div>
      {children}
    </div>
  );
};

export default SectionShell;
